import React from "react"
import { useTranslation } from "react-i18next"
import { selectedPages } from "@services/pdf/generator"
import * as styles from "./PdfBuilder.module.scss"
import { useBuilder } from "./context"

// iOS PDFOptions.all — display order
const allOptions = [
	{ key: "branded", labelKey: "pdfBuilder.optionBranded" },
	{ key: "price", labelKey: "pdfBuilder.optionPrice" },
	{ key: "notes", labelKey: "pdfBuilder.optionNotes" },
	{ key: "provenance", labelKey: "pdfBuilder.optionProvenance" },
	{ key: "exhibition", labelKey: "pdfBuilder.optionExhibition" },
	{ key: "literature", labelKey: "pdfBuilder.optionLiterature" },
] as const

/** Persistent right sidebar: include-options + document summary. */
export const OptionsPanel: React.FC = () => {
	const { state, dispatch, assets } = useBuilder()
	const { t } = useTranslation()

	const pageCount = selectedPages(state.contentRows).length + (state.coverRow.pages.some((p) => p.isSelected) ? 1 : 0)

	return (
		<aside className={styles.sidebar}>
			<h3 className={styles.sectionTitle}>{t("pdfBuilder.optionsTitle")}</h3>
			{allOptions
				.filter((option) => option.key !== "branded" || assets.hasBrand)
				.map((option) => (
					<label key={option.key} className={styles.optionRow}>
						<input
							type="checkbox"
							checked={state.options.activeOptions.includes(option.key)}
							onChange={() => dispatch({ type: "toggleOption", option: option.key })}
							data-testid={`pdf-option-${option.key}`}
						/>
						<span>{t(option.labelKey)}</span>
					</label>
				))}

			<div className={styles.summaryBlock}>
				<div>{t("pdfBuilder.pagesSelected", { count: pageCount })}</div>
			</div>
		</aside>
	)
}
